module.exports = __webpack_public_path__ + "static/media/img-07.25203286.jpg";